import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";
import { useSelectedOrganization } from "@/hooks/useCurrentUser";

export type FeedbackType = "Bug" | "Recommendation";

export type SubmitFeedbackPayload = {
  type: FeedbackType;
  title: string;
  description: string;
};

export function useSubmitFeedback() {
  const { selectedOrganization } = useSelectedOrganization();

  return useMutation({
    mutationFn: async (payload: SubmitFeedbackPayload) => {
      const res = await axiosInstance.post<{ id: string }>("/feedback", {
        ...payload,
        pageUrl: typeof window !== "undefined" ? window.location.href : undefined,
        userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
        organizationId: selectedOrganization?.organization.id,
      });
      return res.data;
    },
  });
}
